export default __webpack_public_path__ + "static/media/doge.2718afb8.png";